module.exports = __webpack_public_path__ + "static/media/eyeslash.a81b2719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/icons/eyeslash.svg
// module id = 730
// module chunks = 0